<section class="agent-team-upload-page">
  <header class="agent-team-upload-page__header">
    <div class="agent-team-upload-page__header-inner">
      <div class="agent-team-upload-page__header-left">
        <button
          type="button"
          class="agent-team-upload-page__back"
          [disabled]="busy()"
          (click)="navigateBack()"
          [attr.aria-label]="'agentTeam.header.back' | translate"
        >
          <mat-icon aria-hidden="true">arrow_back</mat-icon>
        </button>
        <div class="agent-team-upload-page__header-text">
          <div class="agent-team-upload-page__eyebrow">{{ 'agentTeam.header.eyebrow' | translate }}</div>
          <h1 class="agent-team-upload-page__title">{{ 'agentTeam.header.title' | translate }}</h1>
        </div>
      </div>
      <div class="agent-team-upload-page__header-actions">
        <button
          type="button"
          class="agent-team-upload-page__cancel"
          data-testid="agent-team-cancel"
          [disabled]="busy()"
          (click)="navigateBack()"
        >
          {{ 'agentTeam.header.cancel' | translate }}
        </button>
        <button
          type="button"
          class="agent-team-upload-page__save"
          data-testid="agent-team-submit"
          [disabled]="!canSubmit()"
          (click)="onSubmit()"
        >
          <mat-icon aria-hidden="true">check</mat-icon>
          <span>{{ 'agentTeam.submit' | translate }}</span>
        </button>
      </div>
    </div>
  </header>

  <div class="agent-team-upload-page__body">
    <section class="agent-team-upload-page__panel" aria-labelledby="agent-team-file-title">
      <div class="agent-team-upload-page__section-title">
        <h2 id="agent-team-file-title">{{ 'agentTeam.file.title' | translate }}</h2>
        <p>{{ 'agentTeam.file.subtitle' | translate }}</p>
      </div>

      <app-file-dropzone
        accept=".json,application/json"
        [hint]="'agentTeam.file.hint' | translate"
        [disabled]="busy()"
        [busy]="busy()"
        (fileSelected)="onFileSelected($event)"
        (cleared)="onFileCleared()"
      />

      @if (fileError(); as error) {
        <p
          class="agent-team-upload-page__notice agent-team-upload-page__notice--error"
          role="alert"
          data-testid="agent-team-file-error"
        >
          {{ 'agentTeam.file.' + error | translate }}
        </p>
      }
      @if (checking()) {
        <p class="agent-team-upload-page__notice" role="status" data-testid="agent-team-checking">
          {{ 'agentTeam.check.loading' | translate }}
        </p>
      }
      @if (checkFailed()) {
        <div
          class="agent-team-upload-page__notice agent-team-upload-page__notice--error"
          role="alert"
          data-testid="agent-team-check-error"
        >
          <span>{{ 'agentTeam.check.error' | translate }}</span>
          <button
            type="button"
            class="agent-team-upload-page__inline-btn"
            data-testid="agent-team-check-retry"
            [disabled]="busy()"
            (click)="runCheck()"
          >
            {{ 'agentTeam.check.retry' | translate }}
          </button>
        </div>
      }
      @if (formatError(); as message) {
        <div
          class="agent-team-upload-page__notice agent-team-upload-page__notice--error"
          role="alert"
          data-testid="agent-team-format-error"
        >
          <div class="agent-team-upload-page__notice-title">{{ 'agentTeam.check.formatError' | translate }}</div>
          <div>{{ message }}</div>
        </div>
      }
    </section>

    @if (resultStats(); as stats) {
      <section
        class="agent-team-upload-page__panel"
        aria-labelledby="agent-team-result-title"
        data-testid="agent-team-result"
      >
        <div class="agent-team-upload-page__section-title">
          <h2 id="agent-team-result-title">{{ 'agentTeam.result.title' | translate }}</h2>
        </div>
        <app-stat-group class="agent-team-upload-page__stats" [items]="stats" />
        @if (hasNewTokens()) {
          <div class="agent-team-upload-page__notice">
            <span>{{ 'agentTeam.result.downloadHint' | translate }}</span>
            <button
              type="button"
              class="agent-team-upload-page__inline-btn"
              data-testid="agent-team-download-again"
              (click)="download()"
            >
              <mat-icon aria-hidden="true">download</mat-icon>
              <span>{{ 'agentTeam.result.downloadAgain' | translate }}</span>
            </button>
          </div>
        } @else {
          <p class="agent-team-upload-page__notice">{{ 'agentTeam.result.noTokens' | translate }}</p>
        }
      </section>
    } @else if (checkResult(); as check) {
      <section
        class="agent-team-upload-page__panel"
        aria-labelledby="agent-team-preview-title"
        data-testid="agent-team-preview"
      >
        <div class="agent-team-upload-page__section-title">
          <h2 id="agent-team-preview-title">{{ 'agentTeam.preview.title' | translate }}</h2>
          <p>{{ 'agentTeam.preview.subtitle' | translate }}</p>
        </div>

        @if (allPresent()) {
          <p
            class="agent-team-upload-page__notice agent-team-upload-page__notice--ok"
            role="status"
            data-testid="agent-team-all-present"
          >
            {{ 'agentTeam.preview.allPresent' | translate }}
          </p>
        }
        @if (!check.fehlerfrei) {
          <p class="agent-team-upload-page__notice agent-team-upload-page__notice--error" role="status">
            {{ 'agentTeam.preview.hasErrors' | translate }}
          </p>
        }
        @if (importInvalid().length > 0) {
          <div
            class="agent-team-upload-page__notice agent-team-upload-page__notice--error"
            role="alert"
            data-testid="agent-team-import-invalid"
          >
            <div class="agent-team-upload-page__notice-title">{{ 'agentTeam.import.invalid' | translate }}</div>
            <ul class="agent-team-upload-page__list">
              @for (fehler of importInvalid(); track $index) {
                <li>
                  {{ 'agentTeam.import.invalidLine' | translate: { kennung: fehler.kennung, kuerzel: fehler.kuerzel } }}
                  {{ 'agentTeam.fehler.' + fehler.code | translate }}
                  @if (fehler.wert) {
                    ({{ fehler.wert }})
                  }
                </li>
              }
            </ul>
          </div>
        }
        @if (importFailed()) {
          <p
            class="agent-team-upload-page__notice agent-team-upload-page__notice--error"
            role="alert"
            data-testid="agent-team-import-error"
          >
            {{ 'agentTeam.import.error' | translate }}
          </p>
        }

        @for (team of check.teams; track team.kennung) {
          <div class="agent-team-upload-page__team" data-testid="agent-team-team">
            <h3 class="agent-team-upload-page__team-title">
              {{ 'agentTeam.preview.team' | translate: { kennung: team.kennung } }}
            </h3>
            @if (team.konten.length === 0) {
              <p class="agent-team-upload-page__muted">{{ 'agentTeam.preview.emptyTeam' | translate }}</p>
            } @else {
              <div class="overview-page__table-card">
                <table mat-table [dataSource]="team.konten" class="overview-page__table">
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      {{ 'agentTeam.preview.columns.name' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let konto">
                      <div class="agent-team-upload-page__name-cell">
                        <app-avatar [name]="fullName(konto)" [size]="36" />
                        <div class="agent-team-upload-page__name-text">
                          <div class="agent-team-upload-page__name-primary">
                            {{ fullName(konto) }}
                            <app-ki-konto-pill />
                          </div>
                          <div class="agent-team-upload-page__name-secondary">{{ konto.kuerzel }}</div>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="stand">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      {{ 'agentTeam.preview.columns.stand' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let konto">
                      <app-status-pill
                        data-testid="agent-team-stand"
                        size="sm"
                        [kind]="standKind(konto.stand)"
                        [label]="'agentTeam.stand.' + konto.stand | translate"
                      />
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="mitgliedschaften">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      {{ 'agentTeam.preview.columns.mitgliedschaften' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let konto">
                      @if (konto.fehlendeMitgliedschaften.length === 0) {
                        <span class="agent-team-upload-page__muted">–</span>
                      } @else {
                        <ul class="agent-team-upload-page__list">
                          @for (mitgliedschaft of konto.fehlendeMitgliedschaften; track $index) {
                            <li data-testid="agent-team-mitgliedschaft">
                              {{ projectLabel(mitgliedschaft) }} ·
                              @if (isKnownRole(mitgliedschaft.rolle)) {
                                {{ 'agentTeam.rolle.' + mitgliedschaft.rolle | translate }}
                              } @else {
                                {{ mitgliedschaft.rolle }}
                              }
                              <span class="agent-team-upload-page__muted">
                                ({{ 'agentTeam.art.' + mitgliedschaft.art | translate }})
                              </span>
                            </li>
                          }
                        </ul>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="token">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      {{ 'agentTeam.preview.columns.token' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let konto">
                      @if (hasFehler(konto)) {
                        <span class="agent-team-upload-page__muted">–</span>
                      } @else if (konto.tokenWirdErzeugt) {
                        {{ 'agentTeam.preview.tokenNeu' | translate }}
                      } @else {
                        <span class="agent-team-upload-page__muted">
                          {{ 'agentTeam.preview.tokenVorhanden' | translate }}
                        </span>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="fehler">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      {{ 'agentTeam.preview.columns.fehler' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let konto">
                      @if (konto.fehler.length === 0) {
                        <span class="agent-team-upload-page__muted">–</span>
                      } @else {
                        <ul class="agent-team-upload-page__list agent-team-upload-page__list--error">
                          @for (fehler of konto.fehler; track $index) {
                            <li data-testid="agent-team-fehler">
                              {{ 'agentTeam.fehler.' + fehler.code | translate }}
                              @if (fehler.wert) {
                                ({{ fehler.wert }})
                              }
                            </li>
                          }
                        </ul>
                      }
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="kontoColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let konto; columns: kontoColumns"
                    class="overview-page__row"
                    data-testid="agent-team-konto-row"
                  ></tr>
                </table>
              </div>
            }
          </div>
        }
      </section>
    }

    @if (nichtMehrInDatei().length > 0) {
      <section
        class="agent-team-upload-page__panel"
        aria-labelledby="agent-team-nicht-mehr-title"
        data-testid="agent-team-nicht-mehr"
      >
        <div class="agent-team-upload-page__section-head">
          <div class="agent-team-upload-page__section-title">
            <h2 id="agent-team-nicht-mehr-title">{{ 'agentTeam.nichtMehr.title' | translate }}</h2>
            <p>{{ 'agentTeam.nichtMehr.subtitle' | translate }}</p>
          </div>
          <button
            type="button"
            class="agent-team-upload-page__secondary-btn"
            data-testid="agent-team-deactivate"
            [disabled]="selected().size === 0 || busy()"
            (click)="requestDeactivation()"
          >
            <mat-icon aria-hidden="true">person_off</mat-icon>
            <span>{{ 'agentTeam.nichtMehr.deactivate' | translate: { count: selected().size } }}</span>
          </button>
        </div>

        <div class="overview-page__table-card">
          <table mat-table [dataSource]="nichtMehrInDatei()" class="overview-page__table">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef scope="col" class="agent-team-upload-page__select-cell">
                <span class="agent-team-upload-page__sr-only">
                  {{ 'agentTeam.nichtMehr.selectColumn' | translate }}
                </span>
              </th>
              <td mat-cell *matCellDef="let account" class="agent-team-upload-page__select-cell">
                @if (canDeactivate(account)) {
                  <mat-checkbox
                    data-testid="agent-team-nicht-mehr-select"
                    [attr.data-user-id]="account.userId"
                    [checked]="selected().has(account.userId)"
                    [disabled]="busy()"
                    [aria-label]="'agentTeam.nichtMehr.select' | translate: { kuerzel: account.kuerzel }"
                    (change)="onSelectionChange(account.userId, $event.checked)"
                  />
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef scope="col">
                {{ 'agentTeam.preview.columns.name' | translate }}
              </th>
              <td mat-cell *matCellDef="let account">
                <div class="agent-team-upload-page__name-cell">
                  <app-avatar [name]="fullName(account)" [size]="36" />
                  <div class="agent-team-upload-page__name-text">
                    <div class="agent-team-upload-page__name-primary">
                      {{ fullName(account) }}
                      <app-ki-konto-pill />
                    </div>
                    <div class="agent-team-upload-page__name-secondary">{{ account.kuerzel }}</div>
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef scope="col">{{ 'agentTeam.nichtMehr.status' | translate }}</th>
              <td mat-cell *matCellDef="let account">
                <div class="agent-team-upload-page__status-cell">
                  <app-status-pill size="sm" [kind]="accountStatusKind(account)" />
                  @if (isDeactivated(account)) {
                    <span class="agent-team-upload-page__muted">
                      {{ 'agentTeam.nichtMehr.deactivated' | translate }}
                    </span>
                  } @else if (isAlreadyInactive(account)) {
                    <span class="agent-team-upload-page__muted">
                      {{ 'agentTeam.nichtMehr.alreadyInactive' | translate }}
                    </span>
                  }
                  @if (deactivationFailed().has(account.userId)) {
                    <span
                      class="agent-team-upload-page__error-text"
                      role="alert"
                      data-testid="agent-team-nicht-mehr-error"
                    >
                      {{ 'agentTeam.nichtMehr.failed' | translate }}
                    </span>
                  }
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="nichtMehrColumns"></tr>
            <tr
              mat-row
              *matRowDef="let account; columns: nichtMehrColumns"
              class="overview-page__row"
              data-testid="agent-team-nicht-mehr-row"
              [attr.data-kuerzel]="account.kuerzel"
            ></tr>
          </table>
        </div>
      </section>
    }
  </div>

  <app-confirm-dialog
    [visible]="confirmingDeactivation()"
    [title]="'agentTeam.nichtMehr.confirmTitle' | translate"
    [message]="'agentTeam.nichtMehr.confirmMessage' | translate: { count: selected().size }"
    [confirmLabel]="'agentTeam.nichtMehr.confirm' | translate"
    [cancelLabel]="'agentTeam.nichtMehr.cancel' | translate"
    icon="person_off"
    confirmColor="warn"
    (confirmed)="confirmDeactivation()"
    (cancelled)="cancelDeactivation()"
  />
</section>
